import React from 'react';
import {View} from 'react-native';
import AVText from '../../AVText';
import AVFormattedCurrency from '../../AVFormattedCurrency';
import {styles} from './recentOrderCanteenStyles';
import {RecentOrderItemModifierType} from 'src/types/RecentOrders';
import {WithLocalizedProps} from 'src/types/PropTypes';
import AccountStore from 'src/stores/AccountStore';
import Styles from 'src/components/Styles';

type RecentOrderCanteenItemModifierProps = WithLocalizedProps & {
  modifier: RecentOrderItemModifierType;
};

const RecentOrderCanteenItemModifier: React.FC<
  RecentOrderCanteenItemModifierProps
> = ({modifier, strings}) => {
  return (
    <View style={styles.modifierRow}>
      <AVText style={styles.modifierText}>
        {modifier.name?.substring(0, 30)}
      </AVText>
      {modifier?.price > 0 && (
        <View style={styles.modifierPriceRow}>
          <AVText style={styles.modifierPrice}>+</AVText>
          <AVFormattedCurrency
            style={styles.modifierPrice}
            value={modifier.price}
            currency={AccountStore.getCurrency()}
            accessibilityLabel={`${strings.Labels.price}: $${modifier.price}`}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
          />
        </View>
      )}
    </View>
  );
};

export default RecentOrderCanteenItemModifier;
